import { Text } from "@mantine/core";

import type { QualityEfficiencyMetricsView } from "../data/types";

import qualityEfficiencyIcon from "./assets/qualityEfficiencyIcon.png";
import sharedStyles from "./cardContent.module.css";
import { computeInverseRingFill, computeMetricStatus } from "./computeRingFill";
import { MetricCard } from "./MetricCard";
import styles from "./qualityEfficiencyCard.module.css";
import { RingArt } from "./RingArt";
import { CRT_TARGET_SECONDS, QUALITY_EFFICIENCY_GRADIENT } from "./targets";

interface Props {
    view: QualityEfficiencyMetricsView;
}

export function QualityEfficiencyCard({ view }: Props) {
    const crt = view.callResolutionTimeSeconds;
    const hasCrt = crt !== null;

    const ringProgress = computeInverseRingFill({ actual: crt, target: CRT_TARGET_SECONDS });
    const status = hasCrt ? computeMetricStatus(ringProgress) : undefined;
    const delta = hasCrt
        ? `${Math.abs(crt - CRT_TARGET_SECONDS)}s ${crt > CRT_TARGET_SECONDS ? "above" : "below"} target`
        : undefined;

    return (
        <MetricCard
            title="Quality and efficiency"
            isLoading={view.isLoading}
            isEmpty={!hasCrt}
            emptyValue="No calls yesterday."
            art={
                <RingArt progress={ringProgress} gradient={QUALITY_EFFICIENCY_GRADIENT} isLoading={view.isLoading}>
                    <img src={qualityEfficiencyIcon} alt="" className={sharedStyles.icon} />
                </RingArt>
            }
            value={
                <>
                    <Text component="span" className={sharedStyles.bigNumber}>
                        {crt !== null ? Math.round(crt) : null}
                    </Text>
                    <Text component="span" className={styles.smallNumber}>
                        sec
                    </Text>
                </>
            }
            footer={<>{CRT_TARGET_SECONDS}s or lower</>}
            status={status}
            delta={delta}
        />
    );
}
